import { gql } from "@codesandbox/api";
import type { FragmentData } from "@codesandbox/api/dist/esm/generated_gql";

const liveSessionFragment = gql.fragments.LiveSession({
  defaultPermission: true,
  guests: {
    permission: true,
    userId: true,
    avatarUrl: true,
    username: true,
  },
  id: true,
  startedAt: true,
  stoppedAt: true,
  vmId: true,
  host: {
    userId: true,
    username: true,
    avatarUrl: true,
  },
});

export type LiveSession = FragmentData<typeof liveSessionFragment>;

export const createLiveSessionMutation = gql.createMutation(
  "CreateLiveSession",
  ({
    defaultPermission,
    sandboxId,
  }: {
    defaultPermission: gql.LiveSessionPermission;
    sandboxId: string;
  }) => ({
    startLiveSession: [
      { defaultPermission, vmId: sandboxId },
      liveSessionFragment,
    ],
  }),
);

export const stopLiveSessionMutation = gql.createMutation(
  "StopLiveSession",
  ({ sandboxId }: { sandboxId: string }) => ({
    stopLiveSession: [{ vmId: sandboxId }, liveSessionFragment],
  }),
);

export const getLiveSessionQuery = gql.createQuery(
  "GetLiveSession",
  ({ sandboxId }: { sandboxId: string }) => ({
    getLiveSession: [{ vmId: sandboxId }, liveSessionFragment],
  }),
);

export const subscribeLiveSession = gql.createSubscription(
  "SubscribeLiveSession",
  ({ sandboxId }: { sandboxId: string }) => ({
    liveSessionEvents: [
      { vmId: sandboxId },
      {
        session: liveSessionFragment,
      },
    ],
  }),
);

export const joinLiveSession = gql.createMutation(
  "JoinLiveSession",
  ({ id }: { id: string }) => ({
    joinLiveSession: [{ id }, liveSessionFragment],
  }),
);

export const setDefaultPermission = gql.createMutation(
  "SetLiveSessionDefaultPermission",
  ({
    sandboxId,
    permission,
  }: {
    sandboxId: string;
    permission: gql.LiveSessionPermission;
  }) => ({
    setLiveSessionDefaultPermission: [
      { vmId: sandboxId, permission },
      {
        defaultPermission: true,
      },
    ],
  }),
);

export const setGuestPermission = gql.createMutation(
  "SetLiveSessionGuestPermission",
  ({
    sandboxId,
    userId,
    permission,
  }: {
    sandboxId: string;
    userId: string;
    permission: gql.LiveSessionPermission;
  }) => ({
    setLiveSessionGuestPermission: [
      { vmId: sandboxId, userId, permission },
      {
        guests: {
          permission: true,
          userId: true,
        },
      },
    ],
  }),
);
